const mytoyotamanualOrigin = 'mytoyotamanual.eu'
const mylexusmanualOrigin = 'mylexusmanual.eu'

const stageDomains = {
  lexusStaging: 'diva.lexus.tweddle-aws.eu'
}

export const specificOriginMap = new Map([
  [mytoyotamanualOrigin, ['toyota', `https://${mytoyotamanualOrigin}`]],
  [mylexusmanualOrigin, ['lexus', `https://${mylexusmanualOrigin}`]],
  [stageDomains.lexusStaging, ['lexus', `https://${stageDomains.lexusStaging}`]]
  // ['localhost', ['lexus', 'http://localhost:3000']] // uncomment this to have only one brand
])

export const specificOriginTitleMap = new Map([
  ['toyota', 'Information for Toyota vehicle owners'],
  ['lexus', 'Information for Lexus vehicle owners']
])

export const determineSpecificOrigin = origin => specificOriginMap.get(origin) || []
